export default __webpack_public_path__ + "static/remote_b.10e7e50bfdd6844e6fcf68e05080e99b.svg";